export const SW_VERSION = "ddf60cd860ba9cb1b919ec3502cf5622";